import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Regions from './pages/Regions';
import Enumerators from './pages/Enumerators';
import AssignUsers from './pages/AssignUsers';
import Surveys from './pages/Surveys';
import SurveyQuestions from './pages/SurveyQuestions';
import SurveyResponses from './pages/SurveyResponses';
import SurveySubmission from './pages/SurveySubmission';
import Knowledge from './pages/Knowledge';
import { isAuthenticated } from './services/authService';

function ProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/regions" element={<Regions />} />
          <Route path="/enumerators" element={<Enumerators />} />
          <Route path="/assign-users" element={<AssignUsers />} />
          <Route path="/surveys" element={<Surveys />} />
          <Route path="/surveys/:surveyId/questions" element={<SurveyQuestions />} />
          <Route path="/surveys/:surveyId/responses" element={<SurveyResponses />} />
          <Route path="/survey-responses" element={<SurveyResponses />} />
          <Route path="/submit-survey" element={<SurveySubmission />} />
          <Route path="/knowledge" element={<Knowledge />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<div className="p-8 text-center"><h1>404 - Page Not Found</h1></div>} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;